/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortDirection } from './SortDirection';
import {
    SortDirectionFromJSON,
    SortDirectionFromJSONTyped,
    SortDirectionToJSON,
    SortDirectionToJSONTyped,
} from './SortDirection';

/**
 * 
 * @export
 * @interface OrderSortingRequestDto
 */
export interface OrderSortingRequestDto {
    /**
     * Sortable fields for Order: description, businessUnit.Name, company.Name, category.Name, date, orderTotal
     * @type {OrderSortingRequestDtoSortByEnum}
     * @memberof OrderSortingRequestDto
     */
    sortBy?: OrderSortingRequestDtoSortByEnum | null;
    /**
     * 
     * @type {SortDirection}
     * @memberof OrderSortingRequestDto
     */
    sortDir?: SortDirection;
}


/**
 * @export
 */
export const OrderSortingRequestDtoSortByEnum = {
    description: 'description',
    businessUnit_Name: 'businessUnit.Name',
    company_Name: 'company.Name',
    category_Name: 'category.Name',
    date: 'date',
    orderTotal: 'orderTotal'
} as const;
export type OrderSortingRequestDtoSortByEnum = typeof OrderSortingRequestDtoSortByEnum[keyof typeof OrderSortingRequestDtoSortByEnum];


/**
 * Check if a given object implements the OrderSortingRequestDto interface.
 */
export function instanceOfOrderSortingRequestDto(value: object): value is OrderSortingRequestDto {
    return true;
}

export function OrderSortingRequestDtoFromJSON(json: any): OrderSortingRequestDto {
    return OrderSortingRequestDtoFromJSONTyped(json, false);
}

export function OrderSortingRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderSortingRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sortBy': json['sortBy'] == null ? undefined : json['sortBy'],
        'sortDir': json['sortDir'] == null ? undefined : SortDirectionFromJSON(json['sortDir']),
    };
}

export function OrderSortingRequestDtoToJSON(json: any): OrderSortingRequestDto {
    return OrderSortingRequestDtoToJSONTyped(json, false);
}

export function OrderSortingRequestDtoToJSONTyped(value?: OrderSortingRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sortBy': value['sortBy'],
        'sortDir': SortDirectionToJSON(value['sortDir']),
    };
}

